import { render, staticRenderFns } from "./CmgLeaderboardMilestoneCompletedModal.vue?vue&type=template&id=f47f2c60&scoped=true&lang=pug"
import script from "./cmg-leaderboard-milestone-completed-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-leaderboard-milestone-completed-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLeaderboardMilestoneCompletedModal.vue?vue&type=style&index=0&id=f47f2c60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47f2c60",
  null
  
)

export default component.exports